import React from "react";
import { connect } from "react-redux";
import {
  setNewRequestSelectionLevel,
  setNewRequestSetSelectedDistrict,
} from "../../redux/newRequest/newRequest.actions";
// import { selectNewRequestSelectedDistrict } from "../../redux/newRequest/newRequest.selectors";
import { SearchSuggestionSingleStyled } from "./searchSuggestionSingle.styles";

const SearchSuggestionSingle = ({
  address,
  title,
  lat,
  long,
  setNewRequestSetSelectedDistrict,

  setNewRequestSelectionLevel,

  children,
  setInputValue,

  ...others
}) => {
  console.log(others, "others");
  // debugger;

  const handle_suggestionSingle_change = (lat, long) => () => {
    setNewRequestSelectionLevel(3);
    setNewRequestSetSelectedDistrict({ lat, long });
    setInputValue("");
    // debugger;
  };

  return (
    <SearchSuggestionSingleStyled
      onClick={handle_suggestionSingle_change(lat, long)}
    >
      <div className="search-suggestion__title font-weight-bold ">{title}</div>
      <div className="search-suggestion__adr mt-1">{address}</div>
      <div>{children}</div>
    </SearchSuggestionSingleStyled>
  );
};

const mapStateToProps = null;

const mapDisptachToProps = (dispatch) => ({
  setNewRequestSetSelectedDistrict: (x) =>
    dispatch(setNewRequestSetSelectedDistrict(x)),

  setNewRequestSelectionLevel: (x) => dispatch(setNewRequestSelectionLevel(x)),
});

export default connect(
  mapStateToProps,
  mapDisptachToProps
)(SearchSuggestionSingle);
